export enum SenceAPI {
  logIn = 'https://sistemas.sence.cl/rce/Registro/IniciarSesion',
  logOut = 'https://sistemas.sence.cl/rce/Registro/CerrarSesion',
}

export const {
  REACT_APP_CHAMELEON_SECRET,
  REACT_APP_CHAMELEON_KEY,
  NODE_ENV,
  REACT_APP_API_URL,
} = process.env

export const API = REACT_APP_API_URL

let url = API || ''
if (!/^https?:\/\//i.test(url)) url = `${location.protocol}//${url}`

export const SENCE_LOGIN_URL = `${url}/integrations/sence/login`
export const SENCE_LOGIN_ERROR_URL = `${url}/integrations/sence/login_error`
export const SENCE_LOGOUT_URL = `${url}/integrations/sence/logout`
export const SENCE_LOGOUT_ERROR_URL = `${url}/integrations/sence/logout_error`

export const FIREBASE_TABLE_REF = 'lms_api'

export const CHAMELEON_SECRET = REACT_APP_CHAMELEON_SECRET
export const CHAMELEON_KEY = REACT_APP_CHAMELEON_KEY
export const isProd = NODE_ENV === 'production'
